import Vue from 'vue'
import DataGridStore from './DataGridStore'
import DataGridLayout from './DataGridLayout'
import KUuid from '../../core/utils/KUuid'
import DataGridHeader from './DataGridHeader'
import DataGridBody from './DataGridBody'
import DataGridFooter from './DataGridFooter'
import DataGridRowFooter from './DataGridRowFooter'
// import DataGridSetting from './DataGridSettings'
import ResizeAware from '../resize-aware'
import { SelectionMode } from './config'
import _ from 'lodash'
import $ from 'jquery'

export default {
  name: 'KDataGrid',
  mixins: [],
  props: {
    data: {
      type: Array,
      // []
      default() {
        return []
      },
    },
    height: {
      validator(value) {
        const type = typeof value
        return type === 'string' || type === 'number'
      },
      default: '',
    },
    // 显示尾部行
    showRowFooter: {
      type: Boolean,
      default: false,
    },
    selectionMode: {
      validator: value => SelectionMode[value] !== null || _.isNil(value) || '',
    },
    selection: {
      validator: (value) => _.isNil(value) || _.isObjectLike(value),
      // null
      default() {
        return null
      },
    },
    selectableData: {
      type: [Array, null],
      default: null,
    },
    checkOnSelect: {
      type: Boolean,
      default: true,
    },
    debug: {
      type: Boolean,
      debug: false,
    },
    border: {
      type: Boolean,
      debug: true,
    },
    borderless: {
      type: Boolean,
      debug: true,
    },
    stripe: {
      type: Boolean,
      debug: true,
    },
    rowClass: {
      type: [Function, String, Array, Object],
      default() {
        return null
      },
    },
  },
  data() {
    const context = this
    const store = new Vue(DataGridStore)
    const layout = new Vue(DataGridLayout)
    store.context = this
    layout.context = this
    store.$on('selectionChange', (v) => {
      context.handleSelectionChange(v)
    })
    return {
      store: Object.freeze(store),
      layout: Object.freeze(layout),
      mounted: false,
      headerMounted: false,
      footerMounted: false,
      containerWidth: '', // 容器宽度
    }
  },
  computed: {
    dataGridId() {
      return 'data-grid-' + KUuid()
    },
    headerReady() {
      return this.mounted && this.headerMounted
    },
    footerReady() {
      return this.mounted && this.footerMounted
    },
    containerStyle() {
      return {
        width: this.containerWidth + 'px',
      }
    },
  },
  watch: {
    data: {
      immediate: true,
      handler(value) {
        this.store.data = value
      },
    },
    headerReady(value) {
      if (value) { // do once only
        this.$nextTick(() => {
          if (this.$slots.headerAffix && this.$slots.headerAffix[0] && this.$slots.headerAffix[0].componentInstance) {
            const affixInstance = this.$slots.headerAffix[0].componentInstance
            affixInstance.apiSetAffixElement(this.$refs.header.$el)
            affixInstance.$on('affixed', () => {
              this.layout.headerAffixed = true
            })
            affixInstance.$on('affixed-bottom', () => {
              this.layout.headerAffixed = true
            })
            affixInstance.$on('affixed-top', () => {
              this.layout.headerAffixed = false
            })
          }
        })
      }
    },
    footerReady(value) {
      if (value) { // do once only
        this.$nextTick(() => {
          if (this.$slots.footerAffix && this.$slots.footerAffix[0] && this.$slots.footerAffix[0].componentInstance) {
            const affixInstance = this.$slots.footerAffix[0].componentInstance
            affixInstance.apiSetAffixElement(this.$refs.footer.$el)
            affixInstance.$on('affixed', () => {
              this.layout.footerAffixed = true
            })
            affixInstance.$on('affixed-bottom', () => {
              this.layout.footerAffixed = true
            })
            affixInstance.$on('affixed-top', () => {
              this.layout.footerAffixed = false
            })
          }
        })
      }
    },
  },
  created() {
  },
  mounted() {
    this.mounted = true
  },
  methods: {
    handleSelectionChange(value) {
      this.$emit('selection-change', value)
    },
    handleHeaderMounted() {
      this.headerMounted = true
    },
    handleFooterMounted() {
      this.footerMounted = true
    },
    handleResize({ width, height }) {
      const $container = $(this.$el)
      this.containerWidth = _.sum([
        width,
        parseInt($container.css('borderLeftWidth')) || 0,
        parseInt($container.css('borderRightWidth')) || 0,
      ])

      // console.log('handleResize: ', width, height)

      this.layout.apiHandleResize({ width, height })
      this.$emit('resize', { width, height })
    },
    renderHeader() {
      const style = {}
      if (this.layout.headerAffixed) {
        style.width = this.containerWidth + 'px'
      }

      return <DataGridHeader
        style={style}
        ref="header"
        onMounted={this.handleHeaderMounted}
      >
        {this.$slots.header}
      </DataGridHeader>
    },
    renderBody() {
      return <DataGridBody ref="body">
        {this.$slots.empty}
      </DataGridBody>
    },
    renderFooter() {
      const style = {}
      if (this.layout.footerAffixed) {
        style.width = this.containerWidth + 'px'
      }

      return <DataGridFooter
        style={style}
        ref="footer"
        onMounted={this.handleFooterMounted}
      >
        {this.renderRowFooter()}
        <div class="km-data-grid__footer--extra">
          {this.$slots.footer}
        </div>
      </DataGridFooter>
    },
    renderRowFooter() {
      if (!this.showRowFooter) {
        return
      }

      return <DataGridRowFooter
        style={this.containerStyle}
        ref="rowFooter"
      />
    },
  },
  render() {
    const style = {
      height: typeof this.height === 'number' ? this.height + 'px' : this.height,
      // ...this.containerStyle,
    }

    const css = {
      'km-data-grid': true,
      'km-data-grid--debug': this.debug,
      'km-data-grid--single-select': this.selectionMode === SelectionMode.Single,
      'km-data-grid--multi-select': this.selectionMode === SelectionMode.Multiple,
      'km-data-grid--bordered': this.border,
      'km-data-grid--borderless': this.borderless,
      'km-data-grid--striped': this.stripe,
    }

    const attrs = {}

    const events = {}

    const data = {
      style: style,
      class: css,
      attrs: attrs,
      on: events,
    }

    return (
      <div {...data}>
        <div class="km-data-grid__seed">
          {this.$slots.default}
          {this.$slots.headerAffix}
          {this.$slots.footerAffix}
        </div>
        <ResizeAware onResize={this.handleResize} />
        {/* <DataGridSetting/> */}

        <div class="km-data-grid__scroll-wrapper">
          <div class="km-data-grid__inner">
            {this.renderHeader()}
            {this.renderBody()}
            {this.renderFooter()}
          </div>
        </div>
      </div>
    )
  },
}
